// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CoverMyMedsInboundEnrollmentCaregiverModel } from './coverMyMedsInboundEnrollmentCaregiverModel.js';
import type { CoverMyMedsInboundEnrollmentPatientModel } from './coverMyMedsInboundEnrollmentPatientModel.js';
import type { CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel } from './coverMyMedsInboundEnrollmentPrescriptionDefinitionModel.js';
import type { CoverMyMedsInboundEnrollmentProviderModel } from './coverMyMedsInboundEnrollmentProviderModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CoverMyMedsInboundEnrollmentHubEnrollmentModel {
    'substitutionsAllowed'?: boolean;
    'caregiver'?: CoverMyMedsInboundEnrollmentCaregiverModel | null;
    'diagnosis'?: string;
    'diagnosisDate'?: string;
    'otherDiagnosis'?: string;
    'drugAllergies'?: string;
    'hasPatientRepresentative'?: boolean;
    'hcpHasPreferredSpecialtyPharmacy'?: boolean;
    'hcpPreferredSpecialtyPharmacy'?: string;
    'isEnrollmentCopayConsented'?: boolean;
    'isPrescriptionSentToSpecialtyPharmacy'?: boolean;
    'isTcpaConsented'?: boolean;
    'key'?: string;
    'medicalCardId'?: string;
    'medicalGroupId'?: string;
    'medicalInsuranceCarrier'?: string;
    'noKnownDrugAllergies'?: boolean;
    'patient'?: CoverMyMedsInboundEnrollmentPatientModel | null;
    'patientMarketingSignatureDate'?: string;
    'patientSignatureDate'?: string;
    'patientCopaySignatureDate'?: string;
    'patientSignatureReceivedDate'?: string;
    'pdf'?: string;
    'preferredContact'?: string;
    'preferredLang'?: Array<string>;
    'preferredLangOther'?: string;
    'prescriptionBin'?: string;
    'prescriptionDefinitions'?: Array<CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel>;
    'prescriptionGroupId'?: string;
    'prescriptionInsuranceCarrier'?: string;
    'prescriptionInsurancePhone'?: string;
    'prescriptionMemberId'?: string;
    'prescriptionPcn'?: string;
    'priorTherapies'?: string;
    'provider'?: CoverMyMedsInboundEnrollmentProviderModel | null;
    'providerSignatureDate'?: string;
    'samplePackProvidedDate'?: string;
    'secondaryMedicalCardId'?: string;
    'secondaryMedicalGroupId'?: string;
    'secondaryMedicalInsuranceCarrier'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CoverMyMedsInboundEnrollmentHubEnrollmentModel>> = [
        {
            "name":     "substitutionsAllowed",
            "baseName": "substitutionsAllowed",
            "type":     "boolean"
        },
        {
            "name":     "caregiver",
            "baseName": "caregiver",
            "type":     "CoverMyMedsInboundEnrollmentCaregiverModel"
        },
        {
            "name":     "diagnosis",
            "baseName": "diagnosis",
            "type":     "string"
        },
        {
            "name":     "diagnosisDate",
            "baseName": "diagnosisDate",
            "type":     "string"
        },
        {
            "name":     "otherDiagnosis",
            "baseName": "otherDiagnosis",
            "type":     "string"
        },
        {
            "name":     "drugAllergies",
            "baseName": "drugAllergies",
            "type":     "string"
        },
        {
            "name":     "hasPatientRepresentative",
            "baseName": "hasPatientRepresentative",
            "type":     "boolean"
        },
        {
            "name":     "hcpHasPreferredSpecialtyPharmacy",
            "baseName": "hcpHasPreferredSpecialtyPharmacy",
            "type":     "boolean"
        },
        {
            "name":     "hcpPreferredSpecialtyPharmacy",
            "baseName": "hcpPreferredSpecialtyPharmacy",
            "type":     "string"
        },
        {
            "name":     "isEnrollmentCopayConsented",
            "baseName": "isEnrollmentCopayConsented",
            "type":     "boolean"
        },
        {
            "name":     "isPrescriptionSentToSpecialtyPharmacy",
            "baseName": "isPrescriptionSentToSpecialtyPharmacy",
            "type":     "boolean"
        },
        {
            "name":     "isTcpaConsented",
            "baseName": "isTcpaConsented",
            "type":     "boolean"
        },
        {
            "name":     "key",
            "baseName": "key",
            "type":     "string"
        },
        {
            "name":     "medicalCardId",
            "baseName": "medicalCardId",
            "type":     "string"
        },
        {
            "name":     "medicalGroupId",
            "baseName": "medicalGroupId",
            "type":     "string"
        },
        {
            "name":     "medicalInsuranceCarrier",
            "baseName": "medicalInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "noKnownDrugAllergies",
            "baseName": "noKnownDrugAllergies",
            "type":     "boolean"
        },
        {
            "name":     "patient",
            "baseName": "patient",
            "type":     "CoverMyMedsInboundEnrollmentPatientModel"
        },
        {
            "name":     "patientMarketingSignatureDate",
            "baseName": "patientMarketingSignatureDate",
            "type":     "string"
        },
        {
            "name":     "patientSignatureDate",
            "baseName": "patientSignatureDate",
            "type":     "string"
        },
        {
            "name":     "patientCopaySignatureDate",
            "baseName": "patientCopaySignatureDate",
            "type":     "string"
        },
        {
            "name":     "patientSignatureReceivedDate",
            "baseName": "patientSignatureReceivedDate",
            "type":     "string"
        },
        {
            "name":     "pdf",
            "baseName": "pdf",
            "type":     "string"
        },
        {
            "name":     "preferredContact",
            "baseName": "preferredContact",
            "type":     "string"
        },
        {
            "name":     "preferredLang",
            "baseName": "preferredLang",
            "type":     "Array<string>"
        },
        {
            "name":     "preferredLangOther",
            "baseName": "preferredLangOther",
            "type":     "string"
        },
        {
            "name":     "prescriptionBin",
            "baseName": "prescriptionBin",
            "type":     "string"
        },
        {
            "name":     "prescriptionDefinitions",
            "baseName": "prescriptionDefinitions",
            "type":     "Array<CoverMyMedsInboundEnrollmentPrescriptionDefinitionModel>"
        },
        {
            "name":     "prescriptionGroupId",
            "baseName": "prescriptionGroupId",
            "type":     "string"
        },
        {
            "name":     "prescriptionInsuranceCarrier",
            "baseName": "prescriptionInsuranceCarrier",
            "type":     "string"
        },
        {
            "name":     "prescriptionInsurancePhone",
            "baseName": "prescriptionInsurancePhone",
            "type":     "string"
        },
        {
            "name":     "prescriptionMemberId",
            "baseName": "prescriptionMemberId",
            "type":     "string"
        },
        {
            "name":     "prescriptionPcn",
            "baseName": "prescriptionPcn",
            "type":     "string"
        },
        {
            "name":     "priorTherapies",
            "baseName": "priorTherapies",
            "type":     "string"
        },
        {
            "name":     "provider",
            "baseName": "provider",
            "type":     "CoverMyMedsInboundEnrollmentProviderModel"
        },
        {
            "name":     "providerSignatureDate",
            "baseName": "providerSignatureDate",
            "type":     "string"
        },
        {
            "name":     "samplePackProvidedDate",
            "baseName": "samplePackProvidedDate",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalCardId",
            "baseName": "secondaryMedicalCardId",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalGroupId",
            "baseName": "secondaryMedicalGroupId",
            "type":     "string"
        },
        {
            "name":     "secondaryMedicalInsuranceCarrier",
            "baseName": "secondaryMedicalInsuranceCarrier",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return CoverMyMedsInboundEnrollmentHubEnrollmentModel.attributeTypeMap;
    }
}
